import { Message } from 'element-ui';
import Vue from 'vue';
import type { ElMessage } from 'element-ui/types/message';

export function setMessage(): ElMessage {
  const messageOffset = 400;

  const IpsMessage = (options) => {
    options = options || {};
    if (typeof options === 'string') {
      options = {
        message: options,
        offset: messageOffset,
      };
    } else {
      options.offset = messageOffset;
    }
    Message(options);
  };

  ['success', 'warning', 'info', 'error'].forEach((type) => {
    IpsMessage[type] = (options) => {
      if (typeof options === 'string') {
        options = {
          message: options,
        };
      }
      options.type = type;
      return IpsMessage(options);
    };
  });
  Vue.prototype.$message = IpsMessage;

  return IpsMessage as ElMessage;
}
